export const appid = '055c8c73f82660202fe7a436e7b76b31';
export const weather_url = 'https://api.openweathermap.org/data/2.5/';
export const weather_type = {
  weather : 'weather',
  forecast: 'forecast',
};

export function getIcon(con, time){
  const date = new Date(time);
  let icon = 'wi wi-';
  icon = (date.getHours() > 7 && date.getHours() < 20) ? icon + 'day-' : icon + 'night-';
  if (con.toLowerCase() === 'clouds'){
    con = 'cloudy'
  }
  if (con.toLowerCase() === 'clear' && date.getHours() > 7 && date.getHours() < 20){
    con = 'sunny'
  }
  icon = icon + con.toLowerCase();
  return icon;
}
